import React, { FC, memo, useCallback, useRef, useState } from 'react'
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'
import ReactPlayer from 'react-player'
import { SectionContainer } from 'containers/SectionContainer'
import { InnerContainer } from 'containers/InnerContainer'
import { TitleSection } from 'components/TitleSection'
import { ButtonMUI } from 'components/ButtonMUI'
import { TitleBottomSection } from 'components/TitleBottomSection'
import { Video } from './Video'

import { staticMultimedia, TStaticMultimedia } from 'utils'

import styles from './styles.module.scss'

interface IProps {
}

// const videos = [
//   'https://www.youtube.com/watch?v=Geik0LBJxe4',
//   'https://www.youtube.com/watch?v=8kzs8NLa1BI',
//   'https://www.youtube.com/watch?v=BmGqMXTtiVY',
//   'https://www.youtube.com/watch?v=5hb_Tr22X6Q',
//   'https://www.youtube.com/watch?v=wySsSG7d5lQ',
//   'https://www.youtube.com/watch?v=yCiTb8CZm30'
// ]

const videos = [
  'https://www.youtube.com/live/Geik0LBJxe4?si=Qs-IbBx5VSMs3shP',
  'https://www.youtube.com/live/8kzs8NLa1BI?si=Xa3NT7DniKxH1ZgR',
  'https://www.youtube.com/live/BmGqMXTtiVY?si=c3OxtJb4GJv0JvjE',
  'https://youtu.be/Vi4Jd4haxtw?si=i7GPeBAh8Xu-qRsa',
  // 'https://youtu.be/5hb_Tr22X6Q?si=HSc_LO5x-wX_pYtO',
  'https://www.youtube.com/live/wySsSG7d5lQ?si=qJOuxOMGN33Em4A8',
  'https://youtu.be/yCiTb8CZm30?si=gcABZg4JtC4lvmpe'
]

const withUs = [
  { urlName: 'withUsGemini', width: '89px' },
  { urlName: 'withUsPolygon', width: '81px' },
  { urlName: 'withUsBudweiser', width: '86px' },
  { urlName: 'withUsHungama', width: '74px' },
  { urlName: 'withUsShop', width: '38px' },
  { urlName: 'withUsTeslasuit', width: '92px' },
  { urlName: 'withUsMoca', width: '50px' },
  { urlName: 'withUsDRESSX', width: '86px' },
  { urlName: 'withUsCentury21', width: '52px' },
  { urlName: 'withUsCNN', width: '43px' },
  { urlName: 'withUsNarodni', width: '114px' },
  { urlName: 'withUsO2', width: '25px' },
  { urlName: 'withUsReadyPlayerMe', width: '41px' },
  { urlName: 'withUsKAREL', width: '31px' },
  { urlName: 'withUsHouseOfLobkowicz', width: '56px' },
  { urlName: 'withUsArtInSpace', width: '78px' },
  { urlName: 'withUsMastercard', width: '41px' },
  { urlName: 'withUsYahoo', width: '69px' },
  { urlName: 'withUsCeskaTV', width: '112px' },
  { urlName: 'withUsZDF', width: '43px' },
  { urlName: 'withUsCeskaSport', width: '55px' }
]

const SpecialSection: FC<IProps> = props => {
  const [playingVideo, setPlayingVideo] = useState('')

  const onClickVideo = useCallback((value: string) => {
    setPlayingVideo(value)
  }, [])

  return (
    <SectionContainer>
      <InnerContainer style={{ height: '100%', alignItems: 'stretch', borderBottom: '1px solid white' }}>
        <div className={styles.specialContainer}>
          <TitleSection title={'Somnium Special Projects: The Extraordinary'}
                        subTitle={'Unique Real World Events'}/>
          <div className={styles.middleBlock}>
            <div className={styles.withUsBlock}>
              <div className={styles.description}>
                Discover the vibrant realm of Somnium Space beyond the virtual. Engage with our exceptional "In Real
                Life" events that unfold across the globe, uniting enthusiasts, creators, and innovators.
                <br/><br/>
                From captivating meetups and immersive fashion showcases to exclusive NFT gallery exhibitions, these
                one-of-a-kind experiences redefine the boundaries between reality and the metaverse.
              </div>

              <div className={styles.withUs}>
                {withUs.map(item => <img
                  key={item.urlName}
                  src={staticMultimedia[item.urlName as TStaticMultimedia]}
                  width={item.width}
                  alt="logo"/>)}
              </div>
            </div>

            <div className={styles.videosBlock}>
              <div className={styles.videosBlockInner}>
                <div className={styles.videosSection}>
                  {videos.slice(0, 2).map(url => <Video key={url} url={url}
                                                        playing={playingVideo === url}
                                                        setPlayingVideo={onClickVideo}/>)}
                </div>
                <div className={styles.videosSection}>
                  {videos.slice(2, 4).map(url => <Video key={url} url={url}
                                                        playing={playingVideo === url}
                                                        setPlayingVideo={onClickVideo}/>)}
                </div>
                <div className={styles.videosSection}>
                  {videos.slice(4, 6).map(url => <Video key={url} url={url}
                                                        playing={playingVideo === url}
                                                        setPlayingVideo={onClickVideo}/>)}
                </div>
              </div>


            </div>

          </div>
          <div className={styles.bottomBlock}>
            <TitleBottomSection
              title={'Join Us for Future Events!'}
              subTitle={'Be part of the magic. Collaborate with us in creating unforgettable moments. Join our team for upcoming events!'}/>
            <div className={styles.rightBox}>
              <a
                href="mailto:vr1@somniumspace.com">
                <ButtonMUI styleType={'white'}
                  // onClick={}
                           type="button"
                           sx={{
                             '&&': {
                               width: '215px',
                               height: '60px',
                               borderRadius: '30px'
                             }
                           }}>Work with us</ButtonMUI>
              </a>
            </div>
          </div>

        </div>
      </InnerContainer>
    </SectionContainer>
  )
}

export default memo(SpecialSection)
